/**
 * Адреса раздела событий. Маршруты объявлены в router/AppRoutes.tsx: журнал, страница события
 * (eventsPage макета, #events/<id>) и образец события. Прежние ссылки журнала ?event=<id>, а также
 * ?id=<id> и ?event_id=<id> уже отправленных уведомлений Slack, Webhook и Jira (DIM и DAR)
 * переводятся на страницу события (eventRedirectPath).
 */

export const EVENTS_PATH = '/activity-log';
/** Прежний параметр журнала с открытой карточкой события */
export const LEGACY_EVENT_PARAM = 'event';
/** Параметры события в прежних ссылках: журнал, уведомления DIM (id) и DAR (event_id) */
const LEGACY_EVENT_PARAMS = [LEGACY_EVENT_PARAM, 'id', 'event_id'] as const;

/** Страница события; учебный ID кодируется целиком */
export function eventPath(id: string): string {
	return `${EVENTS_PATH}/${encodeURIComponent(id)}`;
}

/** Образец данных события */
export function eventSamplePath(id: string): string {
	return `${eventPath(id)}/sample`;
}

/**
 * Адрес страницы события для прежней ссылки журнала или уведомления: остальные параметры
 * (учебный экземпляр) сохраняются; без параметра события — null
 */
export function eventRedirectPath(search: string): string | null {
	const params = new URLSearchParams(search);
	const param = LEGACY_EVENT_PARAMS.find((name) => params.get(name));
	if (!param) return null;
	const id = params.get(param)!;
	params.delete(param);
	const rest = params.toString();
	return rest ? `${eventPath(id)}?${rest}` : eventPath(id);
}
